import { FC, useEffect, useState } from 'react';

import { Box } from '@base-app';
import { CheckboxProps } from './Checkbox.types';
import {
  CheckedCheckboxIconStyled,
  CheckboxIconStyled,
  CheckboxContainerStyled,
  InputCheckboxStyled,
  LabelStyled,
  CheckboxContainerErrorStyled,
  ErrorBoxStyled,
  CautionIconStyled,
  ErrorDescriptionStyled,
} from './Checkbox.styles';

const Checkbox: FC<CheckboxProps> = (props) => {
  const {
    checked,
    defaultChecked,
    disabled,
    id,
    label,
    labelstyles,
    error,
    errorDescription,
    testId = 'check-test-id',
    secondaryLabel,
  } = props;

  const [isChecked, setIsChecked] = useState(defaultChecked ?? checked);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    if (event.target === null) {
      return;
    }
    setIsChecked(event.target.checked);

    props.onChange(event.target.checked);
  };

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <CheckboxContainerErrorStyled>
      <LabelStyled htmlFor={id}>
        <CheckboxContainerStyled>
          <InputCheckboxStyled
            type="checkbox"
            aria-checked={isChecked}
            {...props}
            data-testid={`checkbox-${id}`}
            defaultChecked={defaultChecked}
            checked={isChecked}
            onChange={handleChange}
            role="checkbox"
          />
          {isChecked === true ? (
            <CheckedCheckboxIconStyled disabled={disabled} />
          ) : (
            <CheckboxIconStyled disabled={disabled} />
          )}
        </CheckboxContainerStyled>
        <Box as="span" css={labelstyles}>
          {label}
          {secondaryLabel && (
            <Box as="span" css={{ fontSize: '$sm', marginLeft: '$1' }}>
              <em>{secondaryLabel}</em>
            </Box>
          )}
        </Box>
      </LabelStyled>
      {error != null && error && (
        <div>
          <ErrorBoxStyled>
            <CautionIconStyled />
            <ErrorDescriptionStyled data-testid={`${testId}-error`}>{errorDescription}</ErrorDescriptionStyled>
          </ErrorBoxStyled>
        </div>
      )}
    </CheckboxContainerErrorStyled>
  );
};
export default Checkbox;
